export default "__VITE_ASSET__4ZQA2Lj7__"